import React from "react";
import { Modal } from "antd";

const ConfirmationModal = ({
    visible,
    title = "Confirmation",
    message,
    onConfirm,
    onCancel,
    confirmText = "Yes",
    cancelText = "No",
}) => {
    return (
        <Modal
            title={title}
            open={visible}
            onOk={onConfirm}
            onCancel={onCancel}
            okText={confirmText}
            cancelText={cancelText}
            
        >
            <p>{message}</p>
        </Modal>
    );
};

export default ConfirmationModal;
